import React from 'react';
import YouTube from 'react-youtube';

const YoutubePlayer = ({ videoURL }) => {
  const youtubeRegex =
    /(?:\/|%3D|v=|vi=)(?<videoID>[0-9A-Za-z_-]{11})(?:[%#?&]|$)/;
  const videoId = videoURL.match(youtubeRegex).groups.videoID;

  return (
    <YouTube
      iframeClassName='learning-module-learning-step-video'
      videoId={videoId}
      id={videoId}
    />
  );
};

export default YoutubePlayer;
